<template>
  <el-dialog
    :title="model.id ? '编辑商品分类' : '新增商品分类'"
    :visible.sync="visible"
    width="700px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="90px"
      size="small"
    >
      <el-form-item label="封面">
        <el-upload
          :action="uploadUrl"
          accept="image/*"
          :headers="uploadHeader"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeAvatarUpload"
        >
          <auth-img
            tag="el-image"
            style="width: 60px; height: 60px"
            :src="model.cover"
            fit="cover"
            v-if="model.cover"
          ></auth-img>
          <span v-else class="font-12">点击上传</span>
        </el-upload>
      </el-form-item>
      <el-form-item label="上级分类" v-if="model.father_name">
        <el-input :value="model.father_name" disabled></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="model.name"></el-input>
      </el-form-item>
      <el-form-item label="展示设置" prop="mp_visible">
        <template slot="label">展示设置<CustomTip :t="1"></CustomTip></template>
        <el-select v-model="model.mp_visible" style="width: 100%">
          <el-option label="不展示" key="1" :value="1"></el-option>
          <el-option label="展示" key="2" :value="2"></el-option>
        </el-select>
        <div class="font-12 text-info mt-5" style="line-height: 1.4em">
          设置为展示时该分类及子分类下的商品才会在小程序商城中展示，若子分类的设置和父级冲突，则子分类按自己的配置规则显示。
        </div>
      </el-form-item>
      <el-form-item label="详情">
        <template slot="label">详情<CustomTip :t="3"></CustomTip></template>
        <RichEditor class="editor mobile" v-model="model.content"></RichEditor>
        <div class="font-12 text-info mt-5" style="line-height: 1.4em">
          为呈现最佳的显示效果，请尽量用图片形式呈现。（将文字内容做为图片后上传）
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import {
  createCommodityCategory,
  updateCommodityCategory,
} from '@/service/getData'
import { urlPerfix } from '@/config/env'
import store from '@/store/store'
import RichEditor from '@/components/rich-editor'

export default {
  components: { RichEditor },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      uploadUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      rules: {
        name: [{ required: true, message: '请填写分类名称' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await updateCommodityCategory(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await createCommodityCategory(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.model.cover = res.data
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = true
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
  },
}
</script>

<style scoped>
/deep/.ql-editor {
  min-height: 100px;
}

/deep/.ql-editor img {
  width: 100% !important;
}

/deep/.ql-formats {
  line-height: 0;
}

/deep/.long .el-select,
/deep/.long .el-input-number {
  width: 100% !important;
}
</style>
